module.exports = __webpack_public_path__ + "img/placeholder.081481cb.svg";